export default __webpack_public_path__ + "static/media/sesion.606942c9.svg";